import React, { createContext, ReactNode, useContext, useState } from 'react';

interface JobProgressState {
  showProgress: boolean;
  lastSeedAdded?: Date;
}

interface JobProgressContextType {
  showProgress: boolean;
  lastSeedAdded?: Date;
  startProgress: () => void;
  stopProgress: () => void;
}

const JobProgressContext = createContext<JobProgressContextType | undefined>(
  undefined
);

export const JobProgressProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<JobProgressState>({ showProgress: false });

  const startProgress = () => {
    setState({
      showProgress: true,
      lastSeedAdded: new Date(),
    });
  };

  const stopProgress = () => {
    setState({
      showProgress: false,
      lastSeedAdded: undefined,
    });
  };

  return (
    <JobProgressContext.Provider
      value={{
        showProgress: state.showProgress,
        lastSeedAdded: state.lastSeedAdded,
        startProgress,
        stopProgress,
      }}
    >
      {children}
    </JobProgressContext.Provider>
  );
};

interface JobProgressState {
  showProgress: boolean;
  lastSeedAdded?: Date;
}

export const useJobProgress = () => {
  const context = useContext(JobProgressContext);
  if (context === undefined) {
    throw new Error('useJobProgress must be used within a JobProgressProvider');
  }
  return context;
};
